/* eslint-disable linebreak-style */
export const REQUEST_SAVED_PROGRAMS = 'REQUEST_SAVED_PROGRAMS';
export const RECEIVE_SAVED_PROGRAMS = 'RECEIVE_SAVED_PROGRAMS';
export const REQUEST_SAVED_PROGRAMS_ERROR = 'REQUEST_SAVED_PROGRAMS_ERROR';
